import React, { useMemo } from "react"

import modStyl from './index.module.scss'
import { useHistory } from "react-router-dom"
import TermsOfService from "../../component/documents/terms-of-service"
import PrivacyPolicy from "../../component/documents/privacy-plicy"

const JunTermsOfService = ()=> {

  const his = useHistory()
  
  const tabs = [
    {label: '用户服务协议', key: 0},
    {label: '隐私政策', key: 1}
  ]

  const change = (i: number)=> {
    his.replace(`/v2/terms-of-service?${i === 1 ? 'privacy-plicy' : ''}`)
  }

  const index = useMemo(()=> {
    const i = his.location.search === '?privacy-plicy' ? 1 : 0
    document.title = tabs[i].label
    return i
  }, [his.location.search])

  return (
    <div className={modStyl.wrapper}>
      <div className={modStyl.header}>
        {
          tabs.map(({key, label})=> (
            <button className={index === key ? modStyl.active : ''} onClick={()=> change(key)} key={key} type="button">{label}</button>
          ))
        }
      </div>
      <div className={modStyl.body}>
        {
          index === 0 ? <TermsOfService/> : <PrivacyPolicy/>
        }
      </div>
    </div>
  )
}

export default JunTermsOfService